import { vxRule } from './validator'
export default {
  // 添加用户
  AddUser: {
    account: vxRule(true, ['Account'], ['blur', 'change'], '请填写账号'),
    pdk: vxRule(true, ['Pdk'], ['blur', 'change'], '请填写密码'),
    deptId: vxRule(true, null, ['blur', 'change'], '请选择所属部门')
  },
  // 添加部门
  Adddepartment: {
    districtId: vxRule(true, null, ['blur', 'change'], '请选择所属区'),
    name: vxRule(true, null, ['blur', 'change'], '请填写部门名称')
  },
  // 添加菜单
  AddMenu: {
    name: vxRule(true, null, ['blur', 'change'], '请输入菜单名称'),
    link: vxRule(true, null, ['blur', 'change'], '请输入菜单路径'),
    description: vxRule(true, null, ['blur', 'change'], '请输入菜单描述')
  },
  // 添加角色
  AddRole: {
    name: vxRule(true, null, ['blur', 'change'], '请输入角色名称'),
    modelId: vxRule(true, null, ['blur', 'change'], '请输入子系统'),
    description: vxRule(true, null, ['blur', 'change'], '请输入角色描述')
  },
  // 添加系统
  AddSystem: {
    name: vxRule(true, null, ['blur', 'change'], '请输入中文名'),
    serviceName: vxRule(true, null, ['blur', 'change'], '请输入服务名'),
    description: vxRule(true, null, ['blur', 'change'], '请输入系统描述')
  },
  // 添加权限
  // AddJurisdiction: {
  //   name: vxRule(true, null, ['blur', 'change'], '请输入权限名称'),
  //   value: vxRule(true, null, ['blur', 'change'], '请输入权限值'),
  //   description: vxRule(true, null, ['blur', 'change'], '请输入权限描述')
  // }
  // 添加接口
  Addinterface: {
    name: vxRule(true, null, ['blur', 'change'], '请输入权限名称'),
    value: vxRule(true, null, ['blur', 'change'], '请输入权限值'),
    description: vxRule(true, null, ['blur', 'change'], '请输入权限描述')
  },
  // 添加接口
  AddinterfaceRule: {
    reqMethod: vxRule(true, null, ['blur', 'change'], '请选择请求方式'),
    type: vxRule(true, null, ['blur', 'change'], '请选择权限类型'),
    urlPattern: vxRule(true, null, ['blur', 'change'], '请输入路径规则'),
    matchType: vxRule(true, null, ['blur', 'change'], '请选择约束类型'),
    modelId: vxRule(true, null, ['blur', 'change'], '请选择子系统')
  }
}
